import SlimSelect from 'slim-select';
import $ from 'jquery';
import Scroll from './scroll';

export default class Select {

    constructor(selectors) {
        this.selectors = selectors;
    }

    init() {
        this.pluginInit();
        this.diableValueClick();
    }

    pluginInit() {
        let selectors = this.selectors;
        let scrollSelect = new Scroll();
        let scrollParameters = {
            cursorcolor: "#ff4713",
            cursorwidth: "7.5px",
            background: "#e8eff1",
            cursorborderradius: '3.8px',
            cursorborder: false,
            autohidemode: false,
            railoffset: { top: 17, left: -29 }
        };

        for (let index = 0; index < selectors.length; index++) {

            let element = selectors[index];

            let settings = {
                select: element,
                showSearch: false,
                placeholder: true,
                disabled: false,
                onChange: function () {
                    let element = $(this.slim.container).find('.ss-list');
                    if (this.slim.multiSelected != null) {
                        let count = $(this.slim.multiSelected.values).find('>div').length;
                        let container = $(this.slim.multiSelected.container);
    
                        if (count>0) {
                            container.find('.ss-counter').html('[ ' + count + ' ]');
                        } else {
                            container.find('.ss-counter').html('');
                        } 
                    }
                },
                afterOpen: function() {
                  // if ($('#filtersForm').length) {
                  //   if (!window.matchMedia("(max-width: 640px)").matches) {
                  //     console.log($(element));
                  //     if ($(element).parents(".filters").hasClass('filters')) {
                  //       setTimeout(function() {
                  //         $('.ss-open').css('margin-top', "0.7rem");
                  //       }, 500)
                  //       // $('html, body').animate({
                  //       //   scrollTop: $('#filtersForm').offset().top + 30 
                  //       // }, 5);
                  //     }

                  //   }
                  // }
                },
                beforeOpen: function () {
                  //if ($('body').hasClass('page-missions-list')) {
                    // $('body').animate({
                    //   scrollTop: 60
                    // }, 500);
                  // {``
                    // if ($('#filtersForm').length) {
                    //   if (!window.matchMedia("(max-width: 640px)").matches) {
                    //     console.log($(element));
                    //     if ($(element).parents(".filters").hasClass('filters')) {
                         
                    //       // $('html, body').animate({
                    //       //   scrollTop: $('#filtersForm').offset().top + 30 
                    //       // }, 5);
                    //     }
                        
                    //   }
                    // }
                     
                  //}
                    if (!window.matchMedia("(max-width: 640px)").matches) {
                        let element = $(this.slim.container).find('.ss-list');
                        scrollSelect.initPlugin(element, scrollParameters);
                    }

                },
                afterClose: function() {

                    if (!window.matchMedia("(max-width: 640px)").matches) {
                        let element = $(this.slim.container).find('.ss-list');
                        element.niceScroll().remove();
                    }
                    
                }
            };

            new SlimSelect(settings);
            

            if (element.hasAttribute("multiple")) {
                $(element).next().find('.ss-multi-selected').append('<span class="ss-counter"></span>');
            }

        }
    }

    diableValueClick() {

        $(document).on('click', '.ss-values', (e) => {
            let parents = $(e.target).parents('.ss-multi-selected');

            if (!$(e.target).is('.ss-disabled')) {
                parents.next('.ss-content').removeClass('ss-open');
                parents.removeClass('ss-open-below');
            }

        });
    }
}